import React, { useState, useEffect, useContext, useRef, useMemo, useCallback } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom'
import { message, Divider, Table, Pagination, Row, Col, InputNumber, Radio, Button, Spin, Tabs, Tag, Space } from 'antd';
import API from '@api/api.js';
import styles from './index.module.scss'
import { AppContext } from '@utils/AppContext';
import eventBus from '@utils/eventBus';
import UpdatePasswordModal from '@view/compoents/personalCenterModal/updatePasswordModal'
import PSAIModal from "@PSAIComponents/PSAIModal";
import QRCode from 'qrcode.react'
import Payment from '@view/compoents/Payment';
import dayjs from 'dayjs';
import JSZip from 'jszip';
import XLSX from "xlsx";
import XLSXStyle from "xlsx-style";

// 充值记录
const PayRecordTable = (props) => {
    // 充值记录
    const [pageSize] = useState(10)
    const [loading2, setLoading2] = useState(false)
    const [pageIndex2, setpageIndex2] = useState(1)
    const [dataSource2, setDataSource2] = useState([])
    const [total2, setTotal2] = useState(0)
    const [sortInfo, setSortInfo] = useState({})
    const columns2 = useMemo(() => [{
        title: '充值编号',
        key: 'id',
        dataIndex: 'id',
    }, {
        title: '充值方式',
        render: (text, record) => (
            <p>{record.tradeChannel == 'wechat_web' ?
                <span className={styles.paytype}><img src={require('@assets/images/pay-wechat.png')} alt="" />  微信</span> : record.tradeChannel == 'offline' ?
                    <span className={styles.paytype}><img src={require('@assets/images/pay-online.png')} alt="" />  线下合约</span> :
                    <span className={styles.paytype}><img src={require('@assets/images/pay-alipay.png')} alt="" />  支付宝</span>}</p>
        )
    }, {
        title: '充值金额',
        render: (text, record) => (
            <p>￥ {record.dealAmount}</p>
        )
    }, {
        title: '下单时间',
        key: 'orderTime',
        dataIndex: 'orderTime',
        sorter: true,
        sortOrder: sortInfo.columnKey == 'orderTime' ? sortInfo.order : null,
    }, {
        title: '生效时间',
        key: 'payTime',
        dataIndex: 'payTime',
    }], [sortInfo])
    const merchantgetOrderList = useCallback(() => {
        setLoading2(true)
        const params = new URLSearchParams()
        params.append('pageIndex', pageIndex2)
        params.append('pageSize', pageSize)
        if (sortInfo && sortInfo.order) {
            params.append('order', sortInfo.order == 'ascend' ? 'asc' : 'desc')
        }
        API.merchantgetOrderList(params).then((res) => {
            setLoading2(false)
            if (res.code === 0) {
                setDataSource2(res.data.items)
                setTotal2(res.data.total)
            } else {
                message.warning(res.message)
            }
        }).catch(() => {
            setLoading2(false)
        })
    }, [pageIndex2, pageSize, sortInfo])
    useEffect(() => {
        merchantgetOrderList()
    }, [pageIndex2, props.force, merchantgetOrderList])
    return (
        dataSource2.length == 0 ? <div className={styles.null_content}></div> :
        <div className={styles.tableBox}>
            <Table
                className="customTable"
                rowKey="id"
                loading={loading2}
                columns={columns2}
                dataSource={dataSource2}
                scroll={{
                    x: 'max-content',
                    y: `max-content`,
                }}
                pagination={{
                    current: pageIndex2,
                    pageSize: pageSize,
                    total: total2,
                    showSizeChanger: false,
                    showQuickJumper: true,
                    hideOnSinglePage: true,
                    placement: ['bottomCenter']
                }}
                onChange={({current, pageSize}, _, sorter) => {
                    setpageIndex2(current)
                    setSortInfo(sorter)
                }}
            />
        </div>
    )
}

export default PayRecordTable